mutation QuickbooksCreateOrUpdateCustomer($input: QuickbooksCreateOrUpdateCustomerInput!) {
    quickbooksCreateOrUpdateCustomer(input: $input) {
        peep {
            id
        }
    }
}
